import axios from "axios";
import { WaiverToCodexService } from "./service";
import { keycloak } from "../../../../../lib/keycloak";
import { createWaiverToDTO, GetAllWaiverToFiltersDTO, GetAllWaiverToResponse, updateWaiverToDTO } from "./dto";
import { downloadFileFromResponse } from "../../../../../utils/download";

export class WaiverToCodexServiceImpl implements WaiverToCodexService {

    public GetAllWaiverToCodex(filters: GetAllWaiverToFiltersDTO): Promise<GetAllWaiverToResponse> {
        return axios.get("/api/waiver-to-codex", {
            params: {
                breakoutType: filters.status !== '' ? filters.status : undefined,
                itemsPerPage: filters.itemsPerPage,
                order: filters.order,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                year: filters.year !== '' ? filters.year : undefined,
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetWaiverToExcel(filters: GetAllWaiverToFiltersDTO): Promise<any> {
        return axios.get("/api/download/waiver-to-codex-excel", {
            params: {
                breakoutType: filters.status !== '' ? filters.status : undefined,
                year: filters.year !== '' ? filters.year : undefined
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => {
            downloadFileFromResponse(response.data, 'liberatoria_a_codex.xls', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        }).catch((error) => {
            console.error('Errore durante il download del file:', error);
        });
    }

    public DownloadWaiverToCodexDoc(id: string): Promise<void> {
        return axios.get(`/api/download/odc-change-waiverto-docx/${id}`, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            },
            responseType: 'text',
        }).then((response) => {
            downloadFileFromResponse(response.data, 'liberatoria.docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
        }).catch((error) => {
            console.error('Errore durante il download del file:', error);
        });
    }

    // CREATE
    public CreateWaiverToCodex(data: createWaiverToDTO): Promise<void> {
        return axios.post("/api/waiver-to-codex",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public UpdateWaiverToCodex(body: updateWaiverToDTO, id: string): Promise<void> {
        return axios.put("/api/waiver-to-codex/" + id,
            body,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

}